<!-- Instructions Section -->
<p *ngIf="question.questionType === 'wordCloud'" class="instructions greyText regularText instruction_container ">
    {{config?.questionTemplateWordCloudInstructions}}
</p>

<p *ngIf="question.questionType === 'checkbox'" class="instructions greyText regularText instruction_container">
        {{config?.questionTemplateCheckboxInstructions}}
</p>
    
<p *ngIf="question.questionType === 'radio'" class="instructions greyText regularText instruction_container">
    {{config?.questionTemplateRadioInstructions}}
</p>